var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatchMaker2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4618 21.8077C13.6385 22.5552 12.371 22.5552 11.5476 21.7969L11.4285 21.6886C5.74098 16.5427 2.02514 13.1736 2.16598 8.97022C2.23098 7.12855 3.17348 5.36272 4.70098 4.32272C7.56098 2.37272 11.0926 3.28272 12.9993 5.51439C14.906 3.28272 18.4376 2.36189 21.2976 4.32272C22.8251 5.36272 23.7676 7.12855 23.8326 8.97022C23.9843 13.1736 20.2576 16.5427 14.5701 21.7102L14.4618 21.8077Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_690_29133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 12.5625H16.0625V16.625C16.0625 17.0719 15.6969 17.4375 15.25 17.4375C14.8031 17.4375 14.4375 17.0719 14.4375 16.625V12.5625H10.375C9.92812 12.5625 9.5625 12.1969 9.5625 11.75C9.5625 11.3031 9.92812 10.9375 10.375 10.9375H14.4375V6.875C14.4375 6.42812 14.8031 6.0625 15.25 6.0625C15.6969 6.0625 16.0625 6.42812 16.0625 6.875V10.9375H20.125C20.5719 10.9375 20.9375 11.3031 20.9375 11.75C20.9375 12.1969 20.5719 12.5625 20.125 12.5625Z",
    fill: "#4384f7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_690_29133",
    x: 1.5,
    y: -1,
    width: 27.5,
    height: 27.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_690_29133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_690_29133",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchMaker2);
export default __webpack_public_path__ + "static/media/MatchMaker2.2bc51ec5.svg";
export { ForwardRef as ReactComponent };